/**
 * Thin wrapper over gtag.
 *
 * gtag is loaded from an async script in index.html, so it may not exist yet on an early
 * interaction — and it never exists during the prerender pass. Every call site guards for
 * that; this keeps the guard in one place.
 */
export function trackEvent(name, params) {
  if (typeof window === 'undefined' || typeof window.gtag !== 'function') return;
  window.gtag('event', name, params);
}
